<template>
  <div>
    <div class="seth-set bg-primary px-6 pt-12 pb-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon icon="ArrowLeftIcon" class="flex" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        Design Collaterals
      </h2>
    </div>
    <!-- <Header title="Design Collaterals" description="" /> -->
    <div class="w-full flex bg-white height-100">
      <el-dialog title="" :visible.sync="isShowDetailsStudio" width="35%">
        <template slot="title"
          ><h3 class="fsize16 Add mb-0 Products text-white">
            Studio Details
          </h3></template
        >

        <Social />
      </el-dialog>

      <div class="flex w-full px-6 py-8 m fixed-top">
        <div class="w-8/12 pr-4">
          <div>
            <!-- <h2 class="text-565656 fsize16 font-semibold border-b pb-4">
              Setups and insights
            </h2> -->

            <div class="grid gap-4 grid-cols-3">
              <div
                class="cursor-pointer effecthover"
                v-for="(item, index) in setupCards"
                :key="'item -' + index"
                @click="handleClick(item.route)"
              >
                <div class="flex items-center bg-lightf4f5f6 border-round p-3">
                  <div class="flex gap-4 items-center w-10/12">
                    <img
                      :src="item.image"
                      class="object-contain w-16 h-16 bg-ec rounded-lg"
                      alt="banh"
                    />

                    <div class="w-full">
                      <h3 class="col-4f fsize14 font-medium mb-0">
                        {{ item.title }}
                      </h3>
                    </div>
                  </div>
                  <div class="w-2/12 flex justify-end cursor-pointer">
                    <!-- <img
                      src="@/assets/images/aright.png"
                      class="w-35px rounded-full"
                    /> -->
                    <div
                      class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
                    >
                      <feather-icon
                        icon="ChevronRightIcon"
                        svgClasses="w-5 h-5"
                        class="text-secondary font-semibold flex"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="cardoptions[0].currency === 'S$'">
            <div class="w-full mt-10">
              <h2 class="text-565656 fsize16 font-semibold border-b">
                Recommendation
              </h2>

              <div class="">
                <div
                  class="flex justify-between items-center mb-6 cursor-pointer"
                  v-for="(item, index) in cardoptions"
                  :key="'item-' + index"
                >
                  <div
                    class="flex gap-6 w-10/12"
                    v-if="item.category === 'Custom'"
                  >
                    <img
                      :src="showImage(item.image)"
                      class="object-contain w-16 h-16 bg-ec rounded-lg"
                      :class="item.class"
                      alt="banh"
                    />

                    <div class="w-full">
                      <h3 class="col-4f text-xl mb-0 font-semibold">
                        {{
                          item.name === "Custom Development"
                            ? "Hire a Designer"
                            : "Custom Development"
                        }}
                      </h3>
                      <p
                        class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                      >
                        {{ item.description }}
                      </p>
                      <p
                        class="font-mediu pt-1 fsize12 text-8f8f8f flex items-center"
                        v-if="!item.isDeducted"
                      >
                        Manhours : {{ item.manhours }}
                      </p>

                      <p
                        @click="showCardDetails(item)"
                        class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
                      >
                        View Details
                      </p>
                    </div>
                  </div>

                  <!-- <div class="w-2/12 flex justify-end cursor-pointer">
                  <el-input-number
                    size="small"
                    @change="itemstotalFunc(item)"
                    :min="1"
                    :max="10"
                  ></el-input-number>
                </div> -->

                  <div class="">
                    <vs-button
                      @click="itemstotalFunc(item)"
                      variant="primary"
                      class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
                      v-if="!isSelectedfunc(item) && item.category === 'Custom'"
                      >Add
                    </vs-button>
                    <vs-button
                      @click="itemstotalFunc(item)"
                      variant="primary"
                      color="danger"
                      class="rounded-full bg-danger border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
                      v-if="isSelectedfunc(item) && item.category === 'Custom'"
                      >Remove
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <BrandKit /> -->
          </div>
          <div>
            <div class="w-full mt-10 pb-10">
              <h2 class="text-565656 fsize16 font-semibold border-b pb-4">
                Recommendation
              </h2>

              <div class="mt-6">
                <div
                  class="flex justify-between items-center mb-6 cursor-pointer"
                  v-for="(item, index) in cardoptions"
                  :key="'item-' + index"
                >
                  <div
                    class="flex gap-6 w-10/12"
                    v-if="item.category !== 'Custom'"
                  >
                    <img
                      :src="showImage(item.image)"
                      class="object-contain w-16 h-16 bg-ec rounded-lg"
                      :class="item.class"
                      alt="banh"
                    />

                    <div class="w-full">
                      <h3 class="col-4f text-xl mb-0 font-semibold">
                        {{ item.name }}
                      </h3>
                      <p
                        class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                      >
                        {{ item.description }}
                      </p>
                      <p
                        class="font-mediu pt-1 fsize12 text-8f8f8f flex items-center"
                        v-if="!item.isDeducted"
                      >
                        Manhours : {{ item.manhours }}
                      </p>

                      <p
                        @click="showCardDetails(item)"
                        class="pt-2 fsize12 text-primary font-semibold text-underline cursor-pointer"
                      >
                        View Details
                      </p>
                    </div>
                  </div>

                  <!-- <div class="w-2/12 flex justify-end cursor-pointer">
                  <el-input-number
                    size="small"
                    @change="itemstotalFunc(item)"
                    :min="1"
                    :max="10"
                  ></el-input-number>
                </div> -->

                  <div class="">
                    <div
                      class="w-2/14 flex justify-end cursor-pointer"
                      v-if="
                        item.category === 'Custom' && item.currency !== 'S$'
                      "
                    >
                      <el-input-number
                        size="small"
                        @change="customItemFunc(item, parseInt(num))"
                        :min="0"
                        :max="10"
                        :step="1"
                        step-strictly
                        v-model="num"
                      ></el-input-number>
                    </div>
                    <vs-button
                      @click="itemstotalFunc(item)"
                      variant="primary"
                      class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
                      v-if="!isSelectedfunc(item) && item.category !== 'Custom'"
                      >Add
                    </vs-button>
                    <vs-button
                      @click="itemstotalFunc(item)"
                      variant="primary"
                      color="danger"
                      class="rounded-full bg-danger border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize12"
                      v-if="isSelectedfunc(item) && item.category !== 'Custom'"
                      >Remove
                    </vs-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <BrandKit /> -->
          </div>
        </div>

        <div class="relative w-4/12 pl-8">
          <StudioSummary />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Plans from "@/views/adminPanel/pages/ecommerce/components/Plans";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import BrandKit from "./components/BrandKit";
import StudioSummary from "./components/StudioSummary";
import Social from "../social/Social";
import { mapState } from "vuex";
import Header from "@/views/adminPanel/layouts/components/Header";
export default {
  components: {
    swiper,
    swiperSlide,
    BrandKit,
    Plans,
    StudioSummary,
    Social,
    Header,
  },
  data() {
    return {
      num: 0,
      isShowDetailsStudio: false,
      setupCards: [
        {
          id: "01",
          title: "My Request",
          image: require("@/assets/images/icons/my request.svg"),
          route: "studio-Myrequest",
        },

        {
          id: "02",

          title: "Assets",
          image: require("@/assets/images/icons/assest.svg"),
          route: "studio-Myassets",
        },
      ],
      swiperOption: {
        slidesPerView: 2.2,
        observer: true,
        observeParents: true,
        spaceBetween: 25,
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          575: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      // cardOptions: [
      //   {
      //     name: "Social Media Kit",
      //     image: require("@/assets/images/card1.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      //   {
      //     name: "Business presentation",
      //     image: require("@/assets/images/card6.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      //   {
      //     name: "Print Collaterals",
      //     image: require("@/assets/images/card2.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      //   {
      //     name: "Branded Videos",
      //     image: require("@/assets/images/card3.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      //   {
      //     name: "Website Banners",
      //     image: require("@/assets/images/card5.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },

      //   {
      //     name: "Website Content",
      //     image: require("@/assets/images/card6.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },

      //   {
      //     name: "Logo Design",
      //     image: require("@/assets/images/card7.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      //   {
      //     name: "Branding",
      //     image: require("@/assets/images/card4.png"),
      //     description: "20,000",
      //     viewDetails: "View Details",
      //     class: "bg-cas",
      //   },
      // ],
      products: [],
      isShowMyRequest: false,
      items: [],
      // isSelected: false,
    };
  },
  computed: {
    ...mapState("studio", ["cardoptions", "itemstotal"]),
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleChat() {
      this.$router.push({ name: "studio-chat" });
    },
    async getServicesFunc() {
      let { data } = await this.$store.dispatch("studio/getServices");
      console.log(data, "services");
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");

      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    showCardDetails(card) {
      this.$store.commit("studio/GET_SELECTED_CARD", card);
      this.isShowDetailsStudio = true;
      console.log(card, "card name");
    },
    async itemstotalFunc(n) {
      Object.assign(n, { quantity: 1 });
      let data = this.itemstotal.findIndex((x) => x._id === n._id);

      if (data > -1) {
        this.items.splice(data, 1);
      } else this.items.push(n);

      this.isSelected = true;

      await this.$store.commit("studio/ITEMS_TOTAL", this.items);
    },
    async customItemFunc(n, num) {
      Object.assign(n, { quantity: num });
      let index = this.itemstotal.findIndex((x) => x._id === n._id);
      if (num === 0) {
        this.items.splice(index, 1);
      } else {
        if (index > -1) this.items.splice(index, 1);
        this.items.push(n);
      }
      await this.$store.commit("studio/ITEMS_TOTAL", this.items);
    },
    isSelectedfunc(value) {
      let data = this.itemstotal.findIndex((x) => x._id === value._id);
      if (data > -1) return true;
      else return false;
    },
  },
  mounted() {
    this.$store.dispatch("user/getProject", {
      projectId: this.selectedProject._id,
    });

    this.getServicesFunc();
    this.$store.commit("studio/ITEMS_TOTAL", []);
  },
};
</script>
